var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgResources1Icon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32.527,
  height: 32.521,
  viewBox: "0 0 32.527 32.521"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#7654fd",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.2
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.061 22.511a7.254 7.254 0 0 1 4.037-13.879",
  "data-name": "Path 275"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.008 28.52a13.053 13.053 0 0 1 4.733-25.667",
  "data-name": "Path 276"
}), /*#__PURE__*/React.createElement("path", {
  d: "m13.135 16.065 5.8-5.8",
  "data-name": "Path 277"
}), /*#__PURE__*/React.createElement("path", {
  d: "m18.935 10.263.791-5.22L24.247.599l.7 3.653 3.653.7-4.445 4.52z",
  "data-name": "Path 278"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.223 23.569a8.352 8.352 0 1 0 8.352-8.352 8.35 8.35 0 0 0-8.352 8.352",
  "data-name": "Path 279"
}), /*#__PURE__*/React.createElement("path", {
  d: "m27.3 21.14-4.044 5.393a1.045 1.045 0 0 1-1.574.111l-2.088-2.088",
  "data-name": "Path 280"
}))));
export default SvgResources1Icon;